
import InstituteTable from '../table.vue'
import ScrollTo from '@/components/scroll_to/index.vue'
import FullLoading from '@/components/full_loading/index.vue'
import ScrollToType from '@/components/scroll_to/type'
import { CommonService } from '@/services'
import { Component, Vue, Ref } from 'vue-property-decorator'

@Component({
    name: 'institute',
    components: {
        InstituteTable,
        ScrollTo,
        FullLoading
    }
})
export default class extends Vue {
    @Ref('scrollRef') private scrollEl!: ScrollToType

    private pageSize = 15
    private pageIndex = 1
    private pageTotal = 0
    private isLoading = true
    private operationList: any[] = []
    private onPageChange(curPage: number) {
        this.pageIndex = curPage
        this.scrollEl.scrollToTop(this.getInstitute)
    }

    private async mounted() {
        this.isLoading = true
        await this.getInstitute()
        this.isLoading = false
    }

    /** 获取数据报告列表 */
    private async getInstitute() {
        const params = {
            page_index: this.pageIndex,
            page_size: this.pageSize
        }
        const result = await CommonService.getOperationList(params)
        if (result.status === 200) {
            this.pageTotal = result.data.page_total
            this.operationList = result.data.list
        }
    }

    // 删除
    private onDelete(institute: any) {
        this.$confirm('你正在删除该媒体流量运营, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
        }).then(() => {
            this.deleteOperation(institute)
        })
    }

    private async deleteOperation(institute: any) {
        this.isLoading = true
        const params = { id: institute.id }
        const result = await CommonService.deleteOperation(params)
        this.isLoading = false
        if (result.status === 200) {
            this.operationList.splice(this.operationList.indexOf(institute), 1)
            this.$message({
                type: 'success',
                message: '删除成功',
                showClose: true
            })
            return
        }
        this.$message({
            type: 'error',
            message: result.message || '发生错误, 请稍后再试',
            showClose: true
        })
    }
}
